export default __webpack_public_path__ + "4c8e932fc5c178a4c1d8e2ec5717cce1.mp3";